export enum BrandSocialMediaCode {
  Facebook = 'FACEBOOK',
  Instagram = 'INSTAGRAM',
  TikTok = 'TIK_TOK',
}
